export default "__VITE_ASSET__YxZZgXRd__"